// Define a generic type for the event data object.
export type DataLayerEvent<T = {}> = {
  event: string;
} & T;

// Function to track events
export function trackEvent<T extends object | undefined>(
  eventName: string,
  additionalData?: T,
): void {
  // Initialize dataLayer if it doesn't exist
  window.dataLayer = window.dataLayer || [];

  // Create the event object, ensuring it always includes the event property
  const eventData: DataLayerEvent<T> = {
    event: eventName,
    ...(additionalData || {}), // Use an empty object if additionalData is undefined
  } as DataLayerEvent<T>; // Assert the type to avoid TypeScript error

  // Push the event object to the dataLayer
  window.dataLayer.push(eventData);
}
